import React, { Component } from 'react'
import { connect } from 'react-redux'
import { BootstrapTable, TableHeaderColumn } from 'react-bootstrap-table'
import { withRouter } from 'react-router-dom'
import Dialog from 'react-bootstrap-dialog'
import apiService from '../services/apiservices'
import {employeesMovementTableReady,rowsPerPageState,searchTextState,paginationState,previousFilterStartDate,previousFilterEndDate} from '../redux/employeesmovement'
import { headerDataUpdate,subHeaderDataUpdate, expiryTokenlogout, buildNumberUpdate } from '../../../redux/user'
import { SearchField } from './TableCustomComponents'
import { Button } from 'react-bootstrap'
import * as Constants from '../../../common/constants'
import '../../../static/css/react-bootstrap-table.css'
import '../static/css/employeesMovementTable.css'

//import {MovementFromTo} from "./DropDowns"


import { EmployeeMovementResponder } from './ActionButtons'



import { CSVLink } from 'react-csv'
import { createXLSheetdata } from '../services/helpers'


import * as Helpers from '../../../common/helpers'


import DateRangePicker from 'react-bootstrap-daterangepicker'
import 'react-bootstrap-daterangepicker/css/daterangepicker.css'
import moment from 'moment'


function filterUnwantedData(employeesMovementData,user) {
    let array = []
    if (employeesMovementData && employeesMovementData.data && employeesMovementData.data.list) {
        array = employeesMovementData.data.list
    }

    let newArray = []
    if (array.length > 0) {
        for (let i = 0; i < array.length; i++) {
            let newLineData = {}
            let lineData = array[i]
            newLineData.id = lineData.id ? lineData.id : ""
            newLineData.status_remarks = lineData.status_remarks ? lineData.status_remarks : ""
            newLineData.movement_remarks = lineData.movement_remarks ? lineData.movement_remarks : ""
            newLineData.moved_on = lineData.moved_on ? Helpers.getDateFormatForUTC(lineData.moved_on) : ""
            newLineData.status_reason = lineData.status_reason && lineData.status_reason.name ? lineData.status_reason.name : ""
            newLineData.movement_reason = lineData.movement_reason && lineData.movement_reason.name ? lineData.movement_reason.name : ""
            newLineData.approver = lineData.approver.name ? lineData.approver.name : ""
            newLineData.status = lineData.status ? lineData.status : ""
            newLineData.to_kitchen = lineData.to_kitchen && lineData.to_kitchen.name ? lineData.to_kitchen.name : ""
            newLineData.to_kitchen_manager_id = lineData.to_kitchen && lineData.to_kitchen.manager_id ? lineData.to_kitchen.manager_id : ""

             newLineData.to_kitchen_code = lineData.to_kitchen && lineData.to_kitchen.code ? lineData.to_kitchen.code : ""


            newLineData.to_kitchen_cluster_manager_id = lineData.to_kitchen && lineData.to_kitchen.cluster && lineData.to_kitchen.cluster.manager_id ? lineData.to_kitchen.cluster.manager_id : ""

            newLineData.to_kitchen_city_manager_id = lineData.to_kitchen && lineData.to_kitchen.city && lineData.to_kitchen.city.manager_id ? lineData.to_kitchen.city.manager_id : ""

            newLineData.employee_city_name = lineData.to_kitchen && lineData.to_kitchen.city && lineData.to_kitchen.city.name ? lineData.to_kitchen.city.name : ""

            newLineData.from_kitchen = lineData.from_kitchen && lineData.from_kitchen.name ? lineData.from_kitchen.name : ""
            newLineData.from_kitchen_code = lineData.from_kitchen && lineData.from_kitchen.code ? lineData.from_kitchen.code : ""

            newLineData.from_kitchen_manager_id = lineData.from_kitchen && lineData.from_kitchen.manager_id ? lineData.from_kitchen.manager_id : ""


            newLineData.from_kitchen_cluster_manager_id = lineData.from_kitchen && lineData.from_kitchen.cluster && lineData.from_kitchen.cluster.manager_id ? lineData.from_kitchen.cluster.manager_id : ""

            newLineData.employee_name = lineData.employee.name ? lineData.employee.name : ""
            newLineData.employee_code = lineData.employee.code ? lineData.employee.code : ""

            newLineData.created_on = lineData.created ? Helpers.getDateTimeFormatForUTC(lineData.created) : ""
            newLineData.modified_on = lineData.modified ? Helpers.getDateTimeFormatForUTC(lineData.modified) : ""

            newLineData.editAccess=false
            if(user.profile_id===newLineData.to_kitchen_manager_id || user.profile_id===newLineData.to_kitchen_cluster_manager_id || user.profile_id===newLineData.to_kitchen_city_manager_id){
                newLineData.editAccess=true
            }

            newLineData.modified_by=""
            if(lineData.modified_details.length>0){
                newLineData.modified_by=lineData.modified_details[0] && lineData.modified_details[0].modified_user && lineData.modified_details[0].modified_user.modified_employee_profile && lineData.modified_details[0].modified_user.modified_employee_profile.name ? lineData.modified_details[0].modified_user.modified_employee_profile.name + " - "+lineData.modified_details[0].modified_user.modified_employee_profile.code : ""
            }


            newLineData.created_by=lineData.created_user && lineData.created_user.created_employee_profile && lineData.created_user.created_employee_profile.name ? lineData.created_user.created_employee_profile.name + " - "+lineData.created_user.created_employee_profile.code : ""

            newArray[i] = newLineData
        }
    }
    return newArray
}


class EmployeesMovementTable extends Component {
    constructor() {
        super()
        this.state = {
            page: 1,
            employeesMovementData: [],
            bodyHeight: "0px",
            tableHeight: "0px",
            filter_movement:"",
            startDate: moment().startOf('month').format("YYYY-MM-DD"),
            endDate: moment().format("YYYY-MM-DD"),
            ranges: {
                'Last Month': [moment().subtract(1, 'month').startOf('month'), moment().subtract(1, 'month').endOf('month')]
            },
            rowCount: 15,            
            rowsPerPageDropupClassname: "dropdown-menu drop-up-closed",
            isRowsPerPageDropupOpen: false,
            paginationMarginBottom: ""
        }
        this.isComponentMounted = true
        this.dialog = null
        this.searchBox = null


        this.CSVData = []
        this.createCSVData = this.createCSVData.bind(this)
    }

    componentWillMount() {
        this.isComponentMounted = true
        this.props.dispatch(employeesMovementTableReady(false))
        this.props.dispatch(headerDataUpdate(Constants.EMPLOYEES_MOVEMENT_TABLE))

        this.props.dispatch(subHeaderDataUpdate())

        window.addEventListener("resize", this.updateDimensions)
        this.updateDimensions()


        let previousFilterStartDate=moment().startOf('month').format("YYYY-MM-DD")
        let previousFilterEndDate=moment().format("YYYY-MM-DD")

         if (this.props.employeesmovement && this.props.employeesmovement.previousFilterStartDate && this.props.employeesmovement.previousFilterStartDate!==undefined) {
            previousFilterStartDate=this.props.employeesmovement.previousFilterStartDate
         }
         if (this.props.employeesmovement && this.props.employeesmovement.previousFilterEndDate && this.props.employeesmovement.previousFilterEndDate!==undefined) {
            previousFilterEndDate=this.props.employeesmovement.previousFilterEndDate
         }

         this.setState({
              startDate:previousFilterStartDate,
              endDate:previousFilterEndDate
         },() => {
            this.getEmployeesMovementData()
        });

        
    }

    componentDidMount() {

    }
    
    updateDimensions = () => {
        this.setState({
            tableHeight: (window.innerHeight - 230) + "px",
            bodyHeight: (window.innerHeight - 65) + "px",
        })
        if (window.innerWidth <= 767) {
            this.setState({
                paginationMarginBottom: "20px"
            })
        } else {
            this.setState({
                paginationMarginBottom: "0px"
            })
        }
    }
    
    getEmployeesMovementData = () => {
        apiService.getEmployeesMovementData(this.state.startDate,this.state.endDate,this.state.filter_movement)
            .then(responseData => {
                if (responseData && this.isComponentMounted) {
                    this.validateBuildNumber(responseData)
                    if (responseData.status === "SUCCESS") {
                        let array = filterUnwantedData(responseData,this.props.user), pageNo = 1
                        if (this.props.employeesmovement && this.props.employeesmovement.previousPaginationValue) {
                            pageNo = this.props.employeesmovement.previousPaginationValue
                        }
                        this.setState({
                            employeesMovementData: array,
                            page: pageNo,
                        })

                        

                        this.createCSVData(array)
                    } else {
                        this.dialog.show({
                            title: "Alert",
                            body: responseData.reason ? responseData.reason : "",
                            actions: [
                                Dialog.OKAction(() => {
                                })
                            ],
                        })
                    }
                }
                this.props.dispatch(employeesMovementTableReady(true))
            })
            .catch(err => {
                console.error("Error data: ", err)
                this.props.dispatch(employeesMovementTableReady(true))
                if (this.isComponentMounted) {
                    this.props.dispatch(expiryTokenlogout(false))
                }
            })
    }
    componentWillUnmount() {
        this.isComponentMounted = false
        window.removeEventListener("resize", this.updateDimensions)
    }

    validateBuildNumber = (data) => {
        if (this.props.user && this.props.user.build_number && data && data.app_build_no) {
            if (this.props.user.build_number === data.app_build_no) {
                //do smthng here
            } else {
               this.props.dispatch(buildNumberUpdate(data.app_build_no))
window.location.reload()
            }
        } else {
            this.props.dispatch(buildNumberUpdate(data.app_build_no))
window.location.reload()
        }
    }

      createCSVData(csvData) {
        let movementList = []
        if (csvData) {
            movementList = JSON.parse(JSON.stringify(csvData))
            movementList = createXLSheetdata(movementList)
        }
        this.CSVData = movementList
    }





    rowsperPageDropdown = () => {
        let value = 15

        if (this.props.employeesmovement && this.props.employeesmovement.previousRowsPerPageValue) {
            value = this.props.employeesmovement.previousRowsPerPageValue
        }

        return (
            <div className="container">
                <div className="dropup">
                    <Button
                        className="btn btn-default dropdown-toggle"
                        onClick={(e) => {
                            e.preventDefault()
                            this.dropUpManager()
                        }}>
                        {value}
                        <span className="caret" style={{ marginLeft: "5px" }}></span></Button>
                    <ul className={this.state.rowsPerPageDropupClassname}>
                        <li><a className="drop-up-a-border-style" onClick={(e) => { this.reformateRows(e, 15) }}>15</a></li>
                        <li><a className="drop-up-a-border-style" onClick={(e) => { this.reformateRows(e, 25) }}>25</a></li>
                        <li><a className="drop-up-a-border-style" onClick={(e) => { this.reformateRows(e, 40) }}>40</a></li>
                        <li><a className="drop-up-a-border-style" onClick={(e) => { this.reformateRows(e, 50) }}>50</a></li>
                    </ul>
                </div>
            </div>
        )
    }

    dropUpManager = () => {
        if (this.state.isRowsPerPageDropupOpen) {
            this.setState({
                rowsPerPageDropupClassname: 'dropdown-menu  drop-up-closed'
            })
        } else {
            this.setState({
                rowsPerPageDropupClassname: 'dropdown-menu  drop-up-open'
            })
        }
        this.setState({ isRowsPerPageDropupOpen: !this.state.isRowsPerPageDropupOpen })
    }

    reformateRows = (e, value) => {
        e.preventDefault()
        this.resetPagination()
        this.props.dispatch(rowsPerPageState(value))
        this.dropUpManager()
    }

    movementFromToChange = (data) => {

        this.setState({
            filter_movement :data.value,
            
        })
    }


renderMovementReason = (cell, row, enumObject, rowIndex,) => {
        
        let reason=""
        
            reason=<p>{row.movement_reason}<br/>[ {row.movement_remarks} ]</p>

        return (<div className="row">
            <div className="col-md-12 col-sm-12 col-xs-12">{reason}</div>
        </div>)
    }

renderStatusReason = (cell, row, enumObject, rowIndex,) => {
        
        let reason=""
        
            reason=<p><span className="movement_status_{row.status}">{row.status}</span>{row.status_reason}<br/>[ {row.status_remarks} ]</p>

        return (<div className={"row movement_status_"+row.status.split(" ").join("_")+""}>
            <div className="col-md-12 col-sm-12 col-xs-12">{reason}</div>
        </div>)
    }






    actionButtonsCreator = (cell, row) => {
        
        let responBtn=""

        if(Helpers.checkPrivileges("/dashboard/employeeMovements/edit",this.props.user) && row.status==="IN TRANSIT" && row.editAccess){
            responBtn=<EmployeeMovementResponder data={row}/>

        }

      return (<div className="row">
            <div className="col-md-12 col-sm-12 col-xs-12">{responBtn}</div>
        </div>)

    }

    

   

    createCustomToolBar = props => {


        let movementDetailsFilename = "employee_movement_data_" + moment().format("MM/DD/YYYY") + "-" +
            moment().format("h:mm:ss") + ".csv"

        let startDate = "", endDate = "", start = "", end = "", label = ""

        startDate = moment(this.state.startDate)
        endDate = moment(this.state.endDate)

        start = moment(startDate).format('DD-MM-YYYY')
        end = moment(endDate).format('DD-MM-YYYY')

        label = start + ' to ' + end;

        if (start === end) {
            label = start
        }

        let firstComponent = ''

        
            firstComponent = <div className="col-md-3 col-sm-12 col-xs-12 div-margins">
                <div className="form-group">
                    <DateRangePicker startDate={startDate}
                        endDate={endDate}
                        ranges={this.state.ranges}
                        showDropdowns={true}
                        onApply={this.onApplyEvent}>
                        <button className="date-picker-button">
                            <div className="pull-left"><i className="fa fa-calendar" /></div>
                            <span style={{ textAlign: 'center' }}>{label}</span>
                            <div className="pull-right">
                                <span className="caret"></span>
                            </div>
                        </button>
                    </DateRangePicker>
                </div>
            </div>


        return (
            <div className="row" style={{ marginLeft: "10px", marginRight: "10px" }}>
                <div className="col-xs-12 col-sm-12 col-md-9 col-lg-9 header-div-margins">
                 {firstComponent}

            {/*
                <div className="col-md-2 col-sm-12 col-xs-12 div-margins">
                    <div className="form-group">
                        <MovementFromTo movementFromToChange={this.movementFromToChange} selectedValue={this.state.filter_movement} />    
                    </div>
                </div>
            */}
                 
                  <div className="col-md-3 col-sm-12 col-xs-12 div-margins">
                        <button className="btn btn-primary button-custom"
                            onClick={(e) => {
                                e.preventDefault()
                                this.getFilteredEmployeesMomentList()
                            }}>
                            Go
                        </button>
                        <button className="btn btn-primary button-custom"
                            style={{ marginLeft: "5px" }}
                            onClick={(e) => {
                                this.resetFilterValues()
                            }}>
                            Clear
                        </button>

                         {(() =>{

                        if(Helpers.checkPrivileges("/dashboard/employeeMovements/list",this.props.user)){
                        return(


                            <CSVLink
                                    data={this.CSVData}
                                    className="btn btn-primary button-custom"
                                    style={{ marginLeft: "10px",background: "#3c8dbc",border:"1px solid #3c8dbc"}}
                                    filename={movementDetailsFilename}>
                                    Export
                                </CSVLink>
                            )
                        }
                    })()}

                    </div>  

                </div>
                <div className="col-xs-12 col-sm-12 col-md-3 col-lg-3 header-search-icon header-div-margins">
                    {props.components.searchPanel}
                </div>
            </div>
        )
    }
    
    createCustomFooter = props => {
        return(
            <div className="row" style={{ marginBottom: this.state.paginationMarginBottom, marginTop: "-20px" }}>
                <div className="col-xs-12 col-sm-4 col-md-4 col-lg-4" style={{ paddingTop: "18px" }}>
                    {props.components.sizePerPageDropdown}
                </div>
                <div className="col-xs-12 col-sm-4 col-md-4 col-lg-4" style={{ paddingTop: "24px",textAlign:"center"}}>
                    {(() => {
                        if(this.state.employeesMovementData.length>=(this.props.employeesmovement.previousPaginationValue*this.props.employeesmovement.previousRowsPerPageValue)){
                            return (
                            <p>
                               Showing {(this.props.employeesmovement.previousPaginationValue*this.props.employeesmovement.previousRowsPerPageValue)-this.props.employeesmovement.previousRowsPerPageValue+1} to {this.props.employeesmovement.previousPaginationValue*this.props.employeesmovement.previousRowsPerPageValue} of {this.state.employeesMovementData.length} results
                            </p>
                            )
                        }else{
                            return (
                            <p>
                               Showing {(this.props.employeesmovement.previousPaginationValue*this.props.employeesmovement.previousRowsPerPageValue)-this.props.employeesmovement.previousRowsPerPageValue+1} to {this.state.employeesMovementData.length} of {this.state.employeesMovementData.length} results
                            </p>
                            )
                        }
                    })()}
                </div>
                <div className="col-xs-12 col-sm-4 col-md-4 col-lg-4 footer-pagination-icons">
                   {props.components.pageList}
                </div>
            </div> 
        )   
    }

    getFilteredEmployeesMomentList = () => {
       
        this.props.dispatch(employeesMovementTableReady(false))
        this.resetSearchAndPagination()
        this.getEmployeesMovementData()
       
    }

    resetSearchAndPagination = () => {
        this.props.dispatch(searchTextState(""))
        this.searchBox.wrappedInstance.refs.searchInput.value = ""
        this.searchBox.props.search("")
        this.resetPagination()
    }

    

    resetFilterValues = () => {
        this.props.dispatch(employeesMovementTableReady(false))
        this.setState({
            startDate: moment().startOf('month').format("YYYY-MM-DD"),
            endDate: moment().format("YYYY-MM-DD"),
            filter_movement: ""
        },() => {
             this.resetPagination()
        
            this.props.dispatch(searchTextState(""))
            this.searchBox.wrappedInstance.refs.searchInput.value = ""
            this.searchBox.props.search("")

            this.props.dispatch(previousFilterStartDate(moment().startOf('month').format("YYYY-MM-DD")))
            this.props.dispatch(previousFilterEndDate(moment().format("YYYY-MM-DD")))

            this.getEmployeesMovementData();
        })

    }




     onApplyEvent = (event, picker) => {
        let startDate = moment(picker.startDate)
        let endDate = moment(picker.endDate)

        let api_start_date=moment(picker.startDate).format("YYYY-MM-DD")
        let api_end_date=moment(picker.endDate).format("YYYY-MM-DD")
        if (endDate.diff(endDate, 'months', true) > 1) {
            this.dialog.show({
                title: "Date chosen is greater than one month",
                body: 'Please choose any Dates within one month and then try again',
                actions: [
                    Dialog.OKAction(() => {
                    })
                ],
            })
        } else {
            if (startDate.isAfter(moment().add(1, 'days')) ||
                endDate.isAfter(moment().add(1, 'days'))) {
                this.dialog.show({
                    title: "Date Chosen is greater than current date",
                    body: 'Please choose any Dates within current date and then try again',
                    actions: [
                        Dialog.OKAction(() => {
                        })
                    ],
                })
            } else {

                this.props.dispatch(previousFilterStartDate(api_start_date))
                this.props.dispatch(previousFilterEndDate(api_end_date))

                this.setState({
                    startDate: api_start_date,
                    endDate: api_end_date
                })
            }
        }
    }




     onPageChange = (page, sizePerPage) => {
        this.props.dispatch(paginationState(page))
        this.setState({
            page: page
        })
    }

    resetPagination = () => {
        if (this.props.employeesmovement && this.props.employeesmovement.previousPaginationValue
            && this.props.employeesmovement.previousPaginationValue !== 1) {
            this.props.dispatch(paginationState(1))
            this.setState({
                page: 1
            })
        }
    }


    render() {
        let sizeperPage = 15

        if (this.props.employeesmovement && this.props.employeesmovement.previousRowsPerPageValue) {
            sizeperPage = this.props.employeesmovement.previousRowsPerPageValue
        }

        const options = {
            page: this.state.page,  // which page you want to show as default
            sizePerPage: sizeperPage,  // which size per page you want to locate as default
            pageStartIndex: 1, // where to start counting the pages
            paginationSize: 3,  // the pagination bar size.
            prePage: 'Prev', // Previous page button text
            nextPage: 'Next', // Next page button text
            firstPage: 'First', // First page button text
            lastPage: 'Last', // Last page button text
            paginationPosition: 'bottom',  // default is bottom, top and both is all available
            sizePerPageListPosition: 'bottom',
            sizePerPageDropDown: this.rowsperPageDropdown,
            searchPanel: (props) => (<SearchField { ...props }
                callback={this.resetPagination}
                ref={el => this.searchBox = el} />),
            toolBar: this.createCustomToolBar,
            paginationPanel: this.createCustomFooter,
            onlyOneExpanding: true,
            expandRowBgColor: '#e1e5ed',
            expandBy: 'column',  //Available value is row and column, default is row.
            onPageChange: this.onPageChange,
        }
        return (
            <div className="employeesMovement-table" style={{ marginBottom: '0px', maxHeight: this.state.bodyHeight }}>
                <Dialog ref={el => this.dialog = el} />
                <BootstrapTable
                    ref='table'
                    options={options}
                    data={this.state.employeesMovementData}
                    pagination={true}
                    hover={false}
                    search={true}
                    headerStyle={{ border: '0px', background: '#626262', color: '#fff' }}
                    tableStyle={{ border: '0px', 'background': 'white' }}
                    bodyStyle={{ border: '0px', overflow: "auto", height: this.state.tableHeight}}
                     >

                      {(() =>{
                        if(Helpers.checkPrivileges("/dashboard/tech/only/access",this.props.user)){
                                return(     
                                       <TableHeaderColumn
                                            dataField="id"
                                            width="80"
                                            dataSort={true}
                                            isKey={true}
                                            expandable={false}
                                            dataAlign='center'
                                            tdStyle={{ whiteSpace: 'normal' }}>
                                            ID
                                        </TableHeaderColumn>
                                    )
                                }else{
                                    return(
                                        <TableHeaderColumn
                                            dataField="id"
                                            width="1"
                                            isKey={true}
                                            hidden={true}
                                            expandable={false}
                                            dataAlign='center'
                                            tdStyle={{ whiteSpace: 'normal' }}>
                                            Id
                                        </TableHeaderColumn>
                                    )
                                }
                        })()}
                    <TableHeaderColumn
                        dataField="employee_code"
                        //width="90"
                        dataSort={true}
                        dataAlign='left'
                        tdStyle={{ whiteSpace: 'normal' }}>
                       Emp. Id
                    </TableHeaderColumn>
                    <TableHeaderColumn
                        dataField="employee_name"
                        //width="90"
                        dataSort={true}
                        dataAlign='left'
                        tdStyle={{ whiteSpace: 'normal' }}>
                       Emp. Name
                    </TableHeaderColumn>
                    <TableHeaderColumn
                        dataField="from_kitchen"
                        //width="90"
                        dataSort={true}
                        dataAlign='left'
                        tdStyle={{ whiteSpace: 'normal' }}>
                       From
                    </TableHeaderColumn>
                    <TableHeaderColumn
                        dataField="to_kitchen"
                        //width="90"
                        dataSort={true}
                        dataAlign='left'
                        tdStyle={{ whiteSpace: 'normal' }}>
                       To
                    </TableHeaderColumn>

                    {/*
                        <TableHeaderColumn
                        dataField="moved_on"
                        dataAlign='left'
                        tdStyle={{ whiteSpace: 'normal' }}>
                       Moved On
                    </TableHeaderColumn>
                    */}

                    <TableHeaderColumn
                        dataFormat={this.renderMovementReason}
                        dataAlign='left'
                        tdStyle={{ whiteSpace: 'normal' }}>
                       Movement Details
                    </TableHeaderColumn>

                     {/*
                    <TableHeaderColumn
                        dataField="status"
                        dataAlign='left'
                        tdStyle={{ whiteSpace: 'normal' }}>
                        Status
                    </TableHeaderColumn>                    
                    */}

                    <TableHeaderColumn
                        dataFormat={this.renderStatusReason}
                        dataAlign='left'
                        tdStyle={{ whiteSpace: 'normal' }}>
                       Status Details
                    </TableHeaderColumn>




                    <TableHeaderColumn
                        dataField="status"
                        dataSort={true}
                        hidden={true}
                        dataAlign='left'
                        tdStyle={{ whiteSpace: 'normal' }}>
                       status
                    </TableHeaderColumn>

                    <TableHeaderColumn
                        dataField="approver"
                        //width="90"
                        dataSort={true}
                        dataAlign='left'
                        tdStyle={{ whiteSpace: 'normal' }}>
                       Approver
                    </TableHeaderColumn>

                    <TableHeaderColumn
                        dataField="created_on"
                        dataAlign='left'
                        tdStyle={{ whiteSpace: 'normal' }}>
                       Created
                    </TableHeaderColumn>


                    <TableHeaderColumn
                        dataAlign='left'                    
                        dataFormat={this.actionButtonsCreator}
                        tdStyle={{ whiteSpace: 'normal' }}>
                       Action
                    </TableHeaderColumn>

                    
                    
                </BootstrapTable>
            </div>
        )
    }

}
const mapStateToProps = (state, ownProps) => {
    return {
        user: state.user,
        employeesmovement: state.employeesmovement
    }
}

export default connect(mapStateToProps)(withRouter(EmployeesMovementTable))


// WEBPACK FOOTER //
// ./src/modules/Employees Movement/Components/EmployeesMovementTable.js